import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import validation from "../utils/validation";
import React from "react";
import { TEAM_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { setTeam } from "../../../../store/slices/applicationManagement/managementSlice";
import { useDispatch, useSelector } from "react-redux";
import { useCreateTeamMutation } from "../../../../store";
import { openErrorToast, openSuccessToast } from "../../../../store/slices/toast/toastSlice";
import { useFormik } from "formik";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

const TeamForm = () => {
  const { teamDialogOpen } = useSelector((state) => state.dialogSlice);
  const { team } = useSelector((state) => state.managementSlice);
  const [postTeam, { isLoading }] = useCreateTeamMutation();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setTeam(null));
    dispatch(closeDialog(TEAM_DIALOG));
  };
  const formik = useFormik({
    initialValues: {
      id: team?.id ?? 0,
      name: team?.name ?? "",
    },
    validationSchema: validation,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      try {
        postTeam({
          id: formik.values.id,
          name: formik.values.name,
          teamIcon: "",
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("Takım Kaydedildi !"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  return (
    <Modal
      open={teamDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          Takım Kaydet
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Takım Adı"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            autoFocus
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default TeamForm;
